module.exports = "/images/thankYouImg.svg";